<template>
  <div class="page-wrapper">
    <div class="title">
      <div>{{ $t('navigation.productSystem2') }}<span v-if="language !== 'en-US'">PRODUCT SYSTEM</span></div>
    </div>
    <div class="content">
      <div class="content-title" :style="{ 'font-size': language == 'en-US' ? '4.2667vw' : '5.0667vw' }">
        {{ currentProduct.name }}
      </div>
      <div :class="language == 'en-US' ? 'content-text-en' : 'content-text'">
        {{ currentProduct.content }}
      </div>
    </div>
    <div class="content-picture">
      <div class="arrow">
        <img class="left" src="@images/icon/ps_arrow_left.png" @click="prevImage" />
      </div>
      <div class="image-container">
        <img class="big-bg" src="@images/bg/ps_big1.gif" alt="" />
        <div class="big-src-root">
          <img v-if="bigSrc" :key="bigSrc" class="big-src fade-image" :src="bigSrc" alt="" @load="onImageLoad" />
        </div>
      </div>
      <div class="arrow" style="text-align: end">
        <img class="right" src="@images/icon/ps_arrow_right.png" @click="nextImage" />
      </div>
    </div>
    <div
      ref="CAROUSEL"
      class="carousel-images"
      :style="{ 'margin-top': language == 'en-US' ? '4.2334vh' : '5.2334vh' }"
    >
      <div class="line"></div>
      <div
        v-for="(item, index) in PRODUCT_LIST"
        :key="item.id || index"
        :class="{ 'image-item': true, 'image-item-bg': position === index }"
        @click="onLogoClick(index)"
      >
        <img class="image fade-image" :src="item.smallUrl" alt="" @load="onImageLoad" />
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from '@/request/api/model'

const CATEGORY_ID = '1985184716741496833'

export default {
  data() {
    return {
      position: 0,
      language: localStorage.getItem('Language'),
      productListCN: [
        {
          name: '光阳蛋业·松花蛋',
          localUrl: require('@images/mobile/product/songhuadan.png'),
          smallUrl: require('@images/mobile/product/songhuadan.png'),
          content:
            '光阳松花皮蛋采用控温腌制，原料均来自于直控蛋鸭养殖场，实现从养殖基地到百姓餐桌全程食品安全管控，蛋白滑润爽口，蛋黄醇厚留香，品质稳定，安全保障，是山姆、永辉、胖东来等优质渠道的主力供应商，并远销欧盟、北美、日本、东南亚等国家，国内外市场占有率处领先地位。'
        }
      ],
      productListEN: [
        {
          name: 'GOOSUN • Preserved Duck Eggs',
          localUrl: require('@images/mobile/product/songhuadan.png'),
          smallUrl: require('@images/mobile/product/songhuadan.png'),
          content: `GOOSUN Preserved Duck Eggs adopt temperature-controlled pickling, Raw materials are sourced from our directly managed duck farms. We implement full-process food safety control from breeding bases to dining tables.
      The egg white is smooth and refreshing, while the yolk is mellow and fragrant. Featuring stable quality and reliable safety, we are a core supplier to premium channels including Sam’s Club, Yonghui and Pandahome.
      Our products are exported to the EU, North America, Japan, Southeast Asia and other regions, holding a leading position in both domestic and international market shares.`
        }
      ]
    }
  },
  computed: {
    PRODUCT_LIST() {
      return this.language === 'zh-CN' ? this.productListCN : this.productListEN
    },
    currentProduct() {
      return this.PRODUCT_LIST[this.position] || {}
    },
    bigSrc() {
      return this.currentProduct.localUrl || ''
    }
  },

  created() {
    if (this.language === 'zh-CN') {
      this.getCNData()
    } else {
      this.getENData()
    }
  },

  methods: {
    onImageLoad(event) {
      event.currentTarget.classList.add('is-loaded')
    },
    async getCNData() {
      this.productListCN = await this.getProductData('0,1')
    },
    async getENData() {
      this.productListEN = await this.getProductData('0,2')
    },
    async getProductData(contentType) {
      try {
        const res = await getData({
          categoryId: CATEGORY_ID,
          contentType,
          publishChannel: '0,2'
        })

        if (!res || res.code !== 0 || !Array.isArray(res.data)) {
          return []
        }

        return res.data.reduce((list, item) => {
          const fileList = Array.isArray(item.contentFileList)
            ? item.contentFileList.filter((url) => typeof url === 'string' && url.trim())
            : []
          const localUrl = fileList[0]

          if (localUrl) {
            list.push({
              id: item.id,
              name: item.contentTitle,
              content: item.contentDescription,
              localUrl,
              smallUrl: localUrl
            })
          }
          return list
        }, [])
      } catch (error) {
        console.error(error)
        return []
      }
    },
    prevImage() {
      if (this.position > 0) {
        this.position -= 1
      }
    },
    nextImage() {
      const count = this.PRODUCT_LIST.length
      if (this.position < count - 1) {
        this.position += 1
      }
    },
    onLogoClick(index) {
      this.position = index
    }
  }
}
</script>
<style scoped lang='scss'>
.page-wrapper {
  width: 100%;
  // height: calc(100vh - 5.7992vh - 5.6577vh - 4.6676vh);
  height: 100%;
  font-family: Microsoft YaHei;
  background: url('~@images/mobile/bg/product_bg.jpg') no-repeat;
  background-size: cover;
  box-sizing: border-box;
  overflow-y: auto;
  .fade-image {
    opacity: 0;
    transition: opacity 600ms ease;
    &.is-loaded {
      opacity: 1;
    }
  }
  .title {
    height: 6.8721vh;
    margin: 0 8vw;
    border-bottom: 1px solid #f0f0f0;
    div {
      padding-top: 3.0775vh;
      font-size: 3.5667vw;
      span {
        margin-left: 2.1333vw;
        color: #666;
        font-size: 2.1333vw;
      }
    }
  }
  .content {
    margin: 1.8388vh 8vw 0 8vw;
    .content-title {
      font-weight: bold;
      font-size: 5.0667vw;
      font-family: Microsoft YaHei;
      margin-bottom: 1.3631vh;
    }
    .content-text {
      font-weight: 300;
      font-size: 2.6667vw;
      color: #333333;
      height: 15.3164vh;
      text-indent: 2em;
      line-height: 5.0667vw;
      // white-space: pre-line;
    }
    .content-text-en {
      font-weight: 300;
      font-size: 2.6667vw;
      color: #333333;
      height: 24.4164vh;
      line-height: 3.7667vw;
      white-space: pre-line;
      overflow-y: auto;
    }
  }
  .content-picture {
    display: flex;
    align-items: center;
    margin: 0 5vw;
    .arrow {
      flex: 1;
      img {
        width: 5.6vw;
        height: 5.6vw;
      }
    }
    .image-container {
      position: relative;
      width: 65.8667vw;
      height: 65.8667vw;
      flex-shrink: 0;
      .big-bg {
        width: 100%;
        height: 100%;
      }
      .big-src-root {
        position: absolute;
        width: 50.1333vw;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        .big-src {
          position: absolute;
          width: 100%;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
  .carousel-images {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5.2334vh;
    .line {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 1px;
      border-top: 1px solid #9d1c21;
      width: 100%;
      // z-index: -1;
    }
    .image-item {
      display: block;
      z-index: 999;
      .image {
        display: block;
        width: 16vw;
        height: 16vw;
        padding: 2.1vw;
      }
    }
    .image-item-bg {
      background: url('~@images/bg/ps_small.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
